module.exports = __webpack_public_path__ + "static/media/240399.a133b02e.png";